export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fashion%20product%20photography%20flat%20lay%20with%20sneakers%20hoodie%20and%20accessories%20on%20warm%20cream%20backdrop%2C%20soft%20natural%20lighting%20from%20window%2C%20minimalist%20aesthetic%2C%20clean%20composition%2C%20modern%20lifestyle%20vibe%2C%20gentle%20warm%20tones%2C%20editorial%20quality%2C%20professional%20product%20display%2C%20no%20text%20no%20logos&width=1920&height=1080&seq=hero-bg-main-001&orientation=landscape"
          alt="GTBuy Spreadsheet fashion products"
          className="w-full h-full object-cover object-top"
        />
      </div>
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-3xl mx-auto text-center px-6">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight mb-4">
          GTBuy Spreadsheet
        </h1>
        <p className="text-lg md:text-xl text-white/80 font-body italic mb-3">
          The Smart Way to Manage Global Product Spreadsheets
        </p>
        <p className="text-sm md:text-base text-white/60 max-w-xl mx-auto mb-8 leading-relaxed">
          A powerful spreadsheet system designed for Kakobuy, Superbuy, and GTBuy users to streamline product tracking, automation, and sourcing efficiency.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full bg-background-50 text-foreground-900 font-medium text-base hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            Access GTBuy Spreadsheet Platform
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full border-2 border-white/70 text-white font-medium text-base hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Learn How It Works
          </a>
        </div>
      </div>
    </section>
  );
}